import SubstanceUse, { SubstanceUseSections } from './SubstanceUse';

export default SubstanceUse;
export { SubstanceUseSections };
